export default __webpack_public_path__ + "static/media/power_ratio_eeg.73904f03.webp";